import { SendBezPripomienokApi } from 'pripomienky-frontend-ts-axios';
import { ClientResponse } from '../../../model/ClientResponse';
import apiConfiguration from '../../configuration/apiConfiguration';
import { pripomienkyPrefixPath } from '../../configuration/apiConfigurationConstants';

const client = new SendBezPripomienokApi(apiConfiguration(pripomienkyPrefixPath));

// eslint-disable-next-line import/prefer-default-export
export const sendBezPripomienok = async (
  type: string,
  year: number,
  index: number,
  headers?: object,
):
  Promise<ClientResponse<void>> => {
  const {
    status,
  } = await client.sendBezPripomienok(
    type,
    year,
    index,
    headers,
  );
  return {
    responseCode: status,
  };
};
